import * as React from 'react';
import { DoneIcon } from '@origin-digital/icon';
import { Heading2, Text } from '@origin-digital/style-guide';
import { Box } from '@origin-digital/layout';

// @ts-ignore
import { contact } from '../../../content.json';

export interface SolarChecklistProps {
  firstName?: string;
}

const renderListItem = (text: string): JSX.Element => {
  return (
    <Box key={text} display={'flex'} paddingY={3}>
      <Box marginRight={3}>
        <DoneIcon color={'lightGreen'} />
      </Box>
      <Text size={'sm'}>{text}</Text>
    </Box>
  );
};

export const SolarChecklist = (props: SolarChecklistProps): JSX.Element => {
  const { firstName = 'Hi' } = props;
  return (
    <React.Fragment>
      <Box marginTop={4}>
        <Heading2
          text={`${firstName}, solar could be perfect for you if...`}
          fontWeight={'medium'}
        />
      </Box>
      <Box marginTop={3} marginBottom={3}>
        {contact.content.intro.list.map((text: string) => renderListItem(text))}
      </Box>
      <Text size={'sm'}>{contact.content.intro.text}</Text>
    </React.Fragment>
  );
};
